import { common } from './EN/common';
import { announce } from './EN/announce'
import { mail } from './EN/mail'
import { sysop } from './EN/sysop'
import { flow } from './EN/flow';
import { eForm } from './EN/eForm';
import { sample } from './EN/sample';
import { moea_ic } from './EN/moea_ic';

export default {
    translation: {
        'common': common,
        'announce': announce,
        'mail': mail,
        'sysop': sysop,
        'flow': flow,
        'eForm': eForm,
        'sample': sample,
        'moea_ic': moea_ic
    },
};
